import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TextItemObject} from '@PosterWhiteboard/items/text-item/text-item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';

export function useGetKeyFromTextItem<T extends keyof TextItemObject>(key: T): TextItemObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item?.gitype === ITEM_TYPE.TEXT) {
      const itemCopy = item as TextItemObject;
      if (itemCopy?.[key] !== undefined) {
        return itemCopy[key];
      }
    }

    return undefined;
  });
}
